<template>
  <div>
    <Modal
      v-model="showModal"
      :title="title"
      :mask-closable="false"
      class="modal"
      width="670"
    >
      <div class="add-wrapper box">
        <!--弹窗中左半部分-->
        <div class="add-left box_f1 box_v">
          <!--搜索框-->
          <Input placeholder="请输入成员名称"
                 v-model="peoplename"
                 @on-enter="inputSearch"
                 class="input"
          />
          <Button type="primary" slot="extra" class="btn" @click="selectAll">{{isSelectAll?'取消全选':'全选'}}</Button>
          <!--搜索结果-->
          <div class="people-list box" id="search">
            <div v-for="(item,index) in searchList" class="people-item box_v" :class="item.isSelect?'active':''" @click="peopleSelect(item)">
              <img :src="item.pic||require('@/assets/images/default.png')" />
              <div class="name" style="margin-bottom: 5px">{{item.name}}</div>
              <div class="name">{{item.nickname}}</div>
              <!--选择后的右上角的对勾-->
              <img
                v-if="item.isSelect"
                class="xuanzhong-icon color"
                src="../assets/images/select.png"
              >
              <slot name="triangle"></slot>
            </div>
          </div>
        </div>
        <!--弹窗中间分割线-->
        <div class="line"></div>
        <!--弹窗中右半部分-->
        <div class="add-right box">
          <div v-for="(item,index) in selectList" class="member-item">
            {{item.name}}
            <i class="iconfont icon-quxiao1" @click="delSelect(item)"></i>
          </div>
        </div>
      </div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class="" :type="item.type" @click="clickFootBtn(item.value,index)" v-for="(item,index) in btnList" :loading="item.loading" >{{item.name}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: 'selectPeople',
    props:{
      title:{
        type:String,
        default:'添加人员'
      },
      searchList:{
        type:Array,
        default: function () {
          return []
        }
      },
      btnLoading:{
        type:Boolean,
        default:false
      },
      btnList:{
        type:Array,
        default:function () {
          return [{
            name:'取消',
            type:'text',
            value:'cancel',
            loading:false,
          },{
            name:'确定',
            type:'primary',
            value:'ok',
            loading:false,
          }]
        }
      }
    },
    data () {
      return {
        peoplename:'',
        selectList:[],
        isSelectAll:false,//是否已经全选  初始未全选
        showModal:false,
      }
    },
    methods:{
      inputSearch () {
        this.$emit('searchPeople',this.peoplename)
      },
      // 选择搜索结果中的人员
      peopleSelect (item) {
        if (item.isSelect) {
          //取消选择
          item.isSelect = false
          //已选择列表中删除此选项
          this.selectList.forEach((_item,_index) => {
            if (item.unionId == _item.unionId) {
              this.selectList.splice(_index,1)
              return
            }
          })
          //此时全选状态一定是未全选
          this.isSelectAll = false
        }else {
          //选择
          item.isSelect = true
          //将此选项加入已选择列表
          this.selectList.push({
            nickname:item.nickname,
            name:item.name,
            unionId:item.unionId
          })
          //已选列表长度  和  搜索结果长度相同  说明已经全选  此时按钮变为取消全选
          if (this.selectList.length == this.searchList.length) this.isSelectAll = true
        }
      },
      //点击右侧删除按钮 取消选择
      delSelect (item) {
        console.log(item)
        //从已选择列表中删除
        this.selectList.forEach((_item,_index) => {
          if (item.unionId == _item.unionId) {
            this.selectList.splice(_index,1)
          }
        })
        console.log(this.searchList)
        //将搜索结果中该人员选择状态变为未选择
        this.searchList.forEach(_item => {
          if (item.unionId == _item.unionId) _item.isSelect = false
        })
        //将是否全选状态  变为 未全选
        this.isSelectAll = false
      },
      submitPeople () {

      },
      // 点击全选/取消全选按钮
      selectAll () {
        if (this.isSelectAll) {
          this.isSelectAll = false
          //点击的是 取消全选按钮
          this.searchList.forEach(item => {
            item.isSelect = false
          })
          this.selectList = []
        }else {
          this.isSelectAll = true
          this.selectList = []
          // 点击的是全选按钮
          this.searchList.forEach(item => {
            item.isSelect = true
            this.selectList.push({
              name:item.name,
              nickname:item.nickname,
              unionId:item.unionId
            })
          })
        }
      },
      //点击底部按钮
      clickFootBtn (value,index) {
        if (value == 'cancel') {
          this.selectList = []
          this.showModal = false
        }else if (value == 'ok' || value == 'no') {
          if (!this.selectList.length) {
            this.$Message.warning('请选择人员')
            return
          }
          this.$emit('submit',value,this.selectList,index)
          this.selectList = []
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .modal /deep/ .ivu-btn {
    padding: 1px 15px 2px;
  }
  .add-wrapper{
    line-height: 1;
    height: 320px;
    .add-left{
      .input {
        margin-bottom: 20px;
      }
      .btn{
        align-self: flex-end;
        margin-bottom: 10px;
      }
      .people-list{
        flex-wrap: wrap;
        overflow-y: scroll;
        padding-top: 10px;
        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
          background-color: #fff;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #fff;
        }
        &::-webkit-scrollbar-thumb {
          height: 20px;
          border-radius: 10px;
          background-color: #ccc;
        }
        .people-item{
          width: 120px;
          height: 150px;
          border-radius: 5px;
          border:1px solid #e5e5e5;
          align-items: center;
          /*justify-content: center;*/
          padding-top: 30px;
          margin-right: 15px;
          margin-bottom: 20px;
          position: relative;
          img{
            height: 50px;
            width: 50px;
            border-radius: 50%;
            margin-bottom: 20px;
          }
          .name{
            font-size: 12px;
            color:#333;
          }
          .xuanzhong-icon {
            position: absolute;
            top: -11px;
            right: -12px;
            height: 20px;
            width: 20px;
          }
        }
        .active{
          border:1px solid #ff7b44;
        }
      }
    }
    .line{
      width: 1px;
      background: #dedede;
      margin:0 20px
    }
    .add-right{
      width: 190px;
      flex-wrap: wrap;
      line-height: 1;
      justify-content: space-between;
      overflow-y: scroll;
      align-content: flex-start;
      &::-webkit-scrollbar {
        width: 2px;
        height: 2px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-thumb {
        height: 20px;
        border-radius: 10px;
        background-color: #ccc;
      }
      .member-item{
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color:#999;
        padding: 0 10px;
        border:1px dashed #d2d2d2;
        border-radius: 4px;
        margin-bottom: 30px;
        .iconfont{
          color:#bbb;
          margin-left: 5px;
        }
      }
    }
  }
</style>
